/* template */
<template><div class="mpx-root-view"><div class="home-main"><div :style='["margin-bottom: 20px; padding: 24px; background: #ffffff;"] | transRpxStyle'><div :style='["margin: 10px 0; border: 3px solid #cccccc"] | transRpxStyle'></div><mpx-button @tap="travelSystem">差旅制度</mpx-button></div><div :style='["text-align: center;"] | transRpxStyle'><div :style='["margin: 10px 0;"] | transRpxStyle'></div></div><div :style='["margin: 10px 0;"] | transRpxStyle'></div><div :style='["margin: 10px 0;"] | transRpxStyle'></div><warm-tips title="温馨提示" :content="(content)"></warm-tips><div :style='["margin: 10px 0;"] | transRpxStyle'></div><refund-reason-card title="请选择退票原因" :content="(reasonContent)"/><div :style='["margin: 10px 0;"] | transRpxStyle'></div></div><travel-system-drawer :show="(travelSystemVisible)" :trainInfoContent="(trainInfoContent)" @close="travelSystem"/></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m1260ba88"}'>
  @import '~@/mixins/stylus/color.styl'

  .home-main
    background-color $train-color-background
    height 100vh
    box-sizing border-box
    overflow auto
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m1260ba88"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./component-demo.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./component-demo.mpx?ctorType=page&index=0&isPage&mpx&type=script")
  const currentOption = global.__mpxOptionsMap["m1260ba88"]
  export default processOption(
    currentOption,
    "page",
    "",
    "",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'journey-site':getComponent(require("./home/components/journey-site/index.mpx?isComponent&outputPath=components%2Findex514292f5%2Findex")),'warm-tips':getComponent(require("../components/warm-tips/index.mpx?isComponent&outputPath=components%2Findexfd0d1b18%2Findex")),'refund-reason-card':getComponent(require("../components/refund-change-reason-card/index.mpx?isComponent&outputPath=components%2Findex8bde42f6%2Findex")),'travel-system-drawer':getComponent(require("../components/travel-system-drawer/index.mpx?isComponent&outputPath=components%2Findexf17fe788%2Findex")),'mpx-button':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-button.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
